import React, { useState, useEffect } from 'react';
import { ComboBox, Dropdown } from '@fluentui/react';
import { Color } from '../../const/Const';

const GridFilterField = (props) => {

    const [value, setValue] = useState([]);
    const [value1, setValue1] = useState([]);
    const [data, setData] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);

    useEffect(() => {
        let tData = [];
        if (props.data?.length > 0) {
            tData = props.data;
            if (props.parentkey) {
                if (props.parentvalue?.length > 0) {
                    let tParentValue = [...props.parentvalue].filter(r => r.fieldname == props.parentkey)?.map(r => r.value);
                    tData = tData.filter(r => tParentValue?.includes(r.parentid));
                } else {
                    tData = [];
                }
            }
        }
        setData(tData);
    }, [props.data, props.parentvalue]);

    const onChanged = (p_value) => {
        let tValue = [...value];
        if (p_value.selected) {
            tValue.push(p_value.key);
        } else {
            let tIndex = tValue.indexOf(p_value.key);
            if (tIndex >= 0) {
                tValue.splice(tIndex, 1);
            }
        }
        setValue(tValue);

        let tRValue = [];
        tValue?.map(r => {
            tRValue.push({
                fieldname: props.keyfield,
                value: r
            });
        });
        props.onChanged(tRValue, props.keyfield);
    }

    const onChangeCombo = (event, option, index, value) => {
        let tValue = [...value1];
        if (option.selected) {
            tValue.push(option.key);
        } else {
            let tIndex = tValue.indexOf(option.key);
            if (tIndex >= 0) {
                tValue.splice(tIndex, 1);
            }
        }
        setValue1(tValue);

        let tRValue = [];
        tValue?.map(r => {
            tRValue.push({
                fieldname: props.keyfield,
                value: r
            });
        });

        let selected = option?.selected;
        if (option) {
            setSelectedKeys(prevSelectedKeys =>
                selected ? [...prevSelectedKeys, option.key] : prevSelectedKeys.filter(k => k !== option.key),
            );
        }
         props.onChanged(tRValue, props.keyfield);
    }

    return (
        <div>
            {props?.combo ?
                <ComboBox
                    multiSelect
                    selectedKey={selectedKeys}
                    placeholder={props.namefield}
                    options={data}
                    onChange={onChangeCombo}
                /> :
                <Dropdown
                    styles={{
                        root: {
                            maxWidth: 180
                        },
                        title: {
                            border: '0px',
                            backgroundColor: Color.grayHeaderBack
                        },
                        callout: {
                            minWidth: 300
                        }
                    }}
                    disabled={data?.length > 0 ? false : true}
                    multiSelect
                    options={data}
                    placeholder={props.namefield}
                    onChanged={onChanged}
                />
            }
        </div>
    );
}

export default GridFilterField;